module.exports = __webpack_public_path__ + "img/Half-sleeve-lion-with-crown-tattoo.jpg";